import "./FormHeader.css";

import classnames from "classnames";
import React from "react";

const FormHeader = ({
  children,
  arrow = false,
}: {
  children: React.ReactNode;
  arrow?: boolean;
}) => {
  const className = classnames("FormHeader", {
    "FormHeader--arrow": arrow,
  });
  return <div className={className}>{children}</div>;
};

export default FormHeader;
